Bingo.Pagination = {};
Bingo.Pagination.page = null;

Bingo.Pagination.toTop = function () {
    $('html, body').animate({
        scrollTop: 0,
    }, 500);
};

Bingo.Pagination.isCurrentPage = function (page) {
    return page === this.page;
};
